export default "__VITE_ASSET__4ef43a26__"